import { createSlice } from "@reduxjs/toolkit";

export const maintenanceSlice = createSlice({
  name: "maintenanceState",
  initialState: {
    isLoading: false,
    applications: [],
    initialApplications: [],
    maintenanceRequestText: "",
    viewMaintenanceRequestModal: false,
  },
  reducers: {
    showViewMaintenanceRequestModal: (state) => {
      state.viewMaintenanceRequestModal = true;
    },
    hideViewMaintenanceRequestModal: (state) => {
      state.viewMaintenanceRequestModal = false;
    },
    setIsMaintenanceApplicationsLoaing: (state, action) => {
      state.isLoading = action.payload;
    },
    setsMaintenanceApplications: (state, action) => {
      state.applications = action.payload;
    },
    setsMaintenanceRequestText: (state, action) => {
      state.maintenanceRequestText = action.payload;
    },
    clearMaintenanceRequestText: (state) => {
      state.maintenanceRequestText = "";
    },
    updateApplictions: (state, action) => {
      const { service_id, updatedProperties } = action.payload;
      const update = state.applications.map((application) => {
        return application.service_id === service_id
          ? { ...application, ...updatedProperties } // Merge existing application with updated properties
          : application;
      });
      state.applications = update;
    },
  },
});
export const {
  setIsMaintenanceApplicationsLoaing,
  setsMaintenanceApplications,
  setsMaintenanceRequestText,
  showViewMaintenanceRequestModal,
  hideViewMaintenanceRequestModal,
  clearMaintenanceRequestText,
  updateApplictions,
} = maintenanceSlice.actions;
export default maintenanceSlice.reducer;
